import './ServiceOrderStatusTag.scss';

import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

import { useCountryContext } from '@/contexts/CountryContext';
import { getServiceOrderStatusString, SERVICE_ORDER_STATUS } from '@/model/ServiceOrder/ServiceOrder';

interface ServiceOrderStatusTagProps {
  serviceOrderStatus: SERVICE_ORDER_STATUS;
}

const ServiceOrderStatusTag = (props: ServiceOrderStatusTagProps) => {
  const { t } = useTranslation();
  const { isBrasilSelected } = useCountryContext();
  const { serviceOrderStatus } = props;

  return (
    <Tag
      color={
        serviceOrderStatus == SERVICE_ORDER_STATUS.CANCELADO
          ? 'default'
          : serviceOrderStatus === SERVICE_ORDER_STATUS.FINALIZADA
            ? 'green'
            : serviceOrderStatus == SERVICE_ORDER_STATUS.PENDIENTE_DE_FACTURACION
              ? 'blue'
              : serviceOrderStatus == SERVICE_ORDER_STATUS.PENDIENTE_DE_COORDINACION
                ? 'orange'
                : 'default'
      }
      className={'ServiceOrderStatusTag'}>
      {t(getServiceOrderStatusString(serviceOrderStatus, isBrasilSelected))}
    </Tag>
  );
};

export default ServiceOrderStatusTag;
